export const noop = (..._: any[]) => {};
export const asyncNoop = async (..._: any[]) => {};
